import React from 'react';
import styled, { css } from 'styled-components';
import classnames from 'classnames';
import { BREAKPOINT, GUTTER, MARGIN } from '@latitude/core/utils/constants';

const StyledCardGroup = styled.div`
  display: grid;
  gap: ${GUTTER.G30};
  margin-top: ${MARGIN.M32};

  grid-template-columns: 1fr;

  @media (min-width: ${BREAKPOINT.MD}) {
    grid-template-columns: repeat(3, 1fr);
  }
`;

const StyledCardGroupItem = styled.div`
  width: 100%;
`;


const CardGroup = props => {
  return (
    <StyledCardGroup
      className={classnames(`card-group`, props.className)}
      style={props.style}
    >
      {props.children}
    </StyledCardGroup>
  );
};

const CardGroupItem = props => (
  <StyledCardGroupItem
    className={classnames(`card-group__item`, props.className)}
    style={props.style}
    col={props.col}
  >
    {props.children}
  </StyledCardGroupItem>
);

export { CardGroup, CardGroupItem };
